import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { apiCall } from "../main/Apicall";
import "../css/others/Table.css";
import Pagination from "../Reusablecomponents/Pagination";
import { ChecklistDetails } from "../Interfaces/Interface";
import { ControlVisibility } from "../Interfaces/Interface";
const ViewChecklistDetails: React.FC = () => {
  const { templateId } = useParams<{ templateId: string }>();
  const [details, setDetails] = useState<ChecklistDetails | null>(null);
  const [, setLoading] = useState<boolean>(true);
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const { isIntegratedChecklist, controls = [] } = location.state || { isIntegratedChecklist: false, controls: [] };
  const [controlVisibility, setControlVisibility] = useState<ControlVisibility>({ pims: controls.includes("PIMS"), isms: controls.includes("ISMS"), bcms: controls.includes("BCMS"), cmmi: controls.includes("CMMI"), soc1: controls.includes("SOC1"), soc2: controls.includes("SOC2"), qms: controls.includes("QMS"), aims: controls.includes("AIMS"), erm: controls.includes("ERM"), itsm: controls.includes("ITSM"), ers: controls.includes("ERS"), ohs: controls.includes("OHS") });
  useEffect(() => {
    setControlVisibility({ pims: controls.includes("PIMS"), isms: controls.includes("ISMS"), bcms: controls.includes("BCMS"), cmmi: controls.includes("CMMI"), soc1: controls.includes("SOC1"), soc2: controls.includes("SOC2"), qms: controls.includes("QMS"), aims: controls.includes("AIMS"), erm: controls.includes("ERM"), itsm: controls.includes("ITSM"), ers: controls.includes("ERS"), ohs: controls.includes("OHS") });
  }, [controls]);
  const fetchChecklistDetails = useCallback(async () => {
    if (!templateId) return;
    setLoading(true);
    try {
      const checklist = await apiCall("get", `/api/checklist/templates/${templateId}/questions`, undefined, { page: currentPage - 1, size: itemsPerPage });
      setDetails({ content: checklist.content.map((item: any) => ({ questionId: item.questionId, questionText: item.questionText, expectedArtifact: item.expectedArtifact, practiceArea: item.practiceArea, pims: item.pims, isms: item.isms, bcms: item.bcms, cmmi: item.cmmi, soc1: item.soc1, soc2: item.soc2, qms: item.qms, aims: item.aims, erm: item.erm, itsm: item.itsm, ers: item.ers, ohs: item.ohs })), totalElements: checklist.totalElements, totalPages: checklist.totalPages });
    } catch (error) {
      console.error("Error fetching checklist details:", error);
    } finally {
      setLoading(false);
    }
  }, [templateId, currentPage, itemsPerPage]);
  useEffect(() => {
    fetchChecklistDetails();
  }, [fetchChecklistDetails]);
  const columnCount = 4 + (isIntegratedChecklist ? Object.values(controlVisibility).filter(visible => visible).length : 0);
  const controlFields = [{ key: "pims", label: "PIMS", visible: controlVisibility.pims }, { key: "isms", label: "ISMS", visible: controlVisibility.isms }, { key: "bcms", label: "BCMS", visible: controlVisibility.bcms }, { key: "cmmi", label: "CMMI", visible: controlVisibility.cmmi }, { key: "soc1", label: "SOC1", visible: controlVisibility.soc1 }, { key: "soc2", label: "SOC2", visible: controlVisibility.soc2 }, { key: "qms", label: "QMS", visible: controlVisibility.qms }, { key: "aims", label: "AIMS", visible: controlVisibility.aims }, { key: "erm", label: "ERM", visible: controlVisibility.erm }, { key: "itsm", label: "ITSM", visible: controlVisibility.itsm }, { key: "ers", label: "ERS", visible: controlVisibility.ers }, { key: "ohs", label: "OHS", visible: controlVisibility.ohs }];
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Checklist Details</h2>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th className="header-width">Question</th>
                <th className="header-width">Expected Artifact</th>
                {!isIntegratedChecklist && <th className="header-width">Control/Practice Area</th>}
                {isIntegratedChecklist && (
                  <>
                    {controlFields
                      .filter(control => control.visible)
                      .map(control => (
                        <th key={control.key} className="header-width">{control.label}</th>
                      ))}
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {details?.content && details.content.length > 0 ? (
                details.content.map((item, index) => (
                  <tr key={item.questionId}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{item.questionText || "N/A"}</td>
                    <td>{item.expectedArtifact || "N/A"}</td>
                    {!isIntegratedChecklist && <td>{item.practiceArea || "N/A"}</td>}
                    {isIntegratedChecklist && (
                      <>
                        {controlFields
                          .filter(control => control.visible)
                          .map(control => (
                            <td key={control.key}>{item[control.key as keyof typeof item] || "N/A"}</td>
                          ))}
                      </>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columnCount} className="no-data">No questions available for this checklist</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={details?.totalPages || 0}
        totalElements={details?.totalElements || 0}
        itemsPerPage={itemsPerPage}
        onPageChange={setCurrentPage}
        onItemsPerPageChange={setItemsPerPage}
      />
    </div>
  );
};
export default ViewChecklistDetails;